import { exportDocumentationToPdfBackend } from './documentationPdfExportBackendHelper';
import { exportDocumentationToPdfFrontend } from './documentationPdfExportFrontendHelper';

export const PDF_EXPORT_STRATEGIES = {
  BACKEND: 'backend',
  FRONTEND: 'frontend',
};

/**
 * Exporta documentación wiki según estrategia configurada.
 * - backend: Puppeteer + Mermaid en Node.js (recomendado producción/VPS)
 * - frontend: html2pdf.js en el navegador (sin dependencias server)
 */
export const exportDocumentationToPdf = async ({
  strategy = PDF_EXPORT_STRATEGIES.BACKEND,
  sourceElement,
  docId,
  title,
  markdown,
  frontmatter = {},
}) => {
  if (strategy === PDF_EXPORT_STRATEGIES.FRONTEND) {
    return exportDocumentationToPdfFrontend(sourceElement, { title });
  }

  return exportDocumentationToPdfBackend({
    docId,
    title,
    markdown,
    frontmatter,
  });
};

export const printDocumentation = (sourceElement) => {
  if (!sourceElement) {
    window.print();
    return;
  }

  document.body.classList.add('docs-print-mode');

  const cleanup = () => {
    document.body.classList.remove('docs-print-mode');
    window.removeEventListener('afterprint', cleanup);
  };

  window.addEventListener('afterprint', cleanup);
  window.print();
};
